import { injectCss } from "../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.rt-attached-editor__text-area.ck-focused{border-top-color:#0000}.rt-attached-editor__container{position:relative}`);